module.exports = __webpack_public_path__ + "img/h3.438e1a8e.png";